// 主图个数
export const mainNum = 5

// 正常最大规格数量 现货+预售发货模式“或“新预售发货模式”最多支持2级规格
export const MAX_SPEC_NUM = 2

export const DELIVERY_DELAY_ONDAY = 9999
export const DELIVERY_DELAY_NEXTDAY = 1
export const DELIVERY_DELAY_TWODAY = 2

export const DELIVERY_DELAY_OPTIONS = [DELIVERY_DELAY_ONDAY, DELIVERY_DELAY_NEXTDAY, DELIVERY_DELAY_TWODAY]

export const DELIVERY_DELAY_THREE = 3
export const DELIVERY_DELAY_FIVE = 5
export const DELIVERY_DELAY_SEVEN = 7
export const DELIVERY_DELAY_TEN = 10
export const DELIVERY_DELAY_FIFTEEN = 15

export const DEFAULT_DELIVERY__DAY = [
    DELIVERY_DELAY_ONDAY,
    DELIVERY_DELAY_NEXTDAY,
    DELIVERY_DELAY_TWODAY,
    DELIVERY_DELAY_THREE,
    DELIVERY_DELAY_FIVE,
    DELIVERY_DELAY_SEVEN,
    DELIVERY_DELAY_TEN,
    DELIVERY_DELAY_FIFTEEN
]

export const DEFAULT_DAY_MAP = {
    [DELIVERY_DELAY_ONDAY]: '当日发',
    [DELIVERY_DELAY_NEXTDAY]: '次日发',
    [DELIVERY_DELAY_TWODAY]: '48小时',
    [DELIVERY_DELAY_THREE]: '3天内',
    [DELIVERY_DELAY_FIVE]: '5天内',
    [DELIVERY_DELAY_SEVEN]: '7天内',
    [DELIVERY_DELAY_TEN]: '10天内',
    [DELIVERY_DELAY_FIFTEEN]: '15天内'
}

//  国际书号为10位或者13位
export const ISBN_10 = 10
export const ISBN_13 = 13

export const DELIVERY_TIME_LABEL = '发货时效'
export const DELIVERY_TIME_REAL_NAME = 'deliveryTime'

export const SPOT_PRE_SALE_KEY = '0' // 现货发货模式
export const FULL_PAYMENT_KEY = '1' // 全款预售发货模式
export const STEP_PRE_SALE_KEY = '2' // 阶梯发货时间
export const SPOT_OPENS_BOOK_KEY = '3' // 现货+预售发货模式
export const NEW_BOOK_KEY = '4' // 新预售发货模式
export const STEP_RULE_V2 = '6' // 新现货+预售

export const SHELF_TEMPLATE = 'shelfTemplate' // 铺货模板内的发货模式
export const SHELF_SHOP = 'shelfShop' // 单个上架的发货模式

export const PRE_SALE_MAP = {
    [SPOT_PRE_SALE_KEY]: {
        name: '现货发货模式',
        key: 'normalRule'
    },
    [FULL_PAYMENT_KEY]: {
        name: '全款预售发货模式',
        key: 'productPresellRule'
    },
    [SPOT_OPENS_BOOK_KEY]: {
        name: '现货+预售发货模式',
        key: 'timeTimePresellRule'
    },
    [NEW_BOOK_KEY]: {
        name: '新预售发货模式',
        key: 'timeSkuPurePresellRule'
    },
    [STEP_RULE_V2]: {
        name: '(新)现货+预售发货模式',
        key: 'stepRuleV2'
    }
}

export const TIME_SALE_STOCK_RULE = [
    {
        timeType: 3,
        timeDesc: '3天内'
    },
    {
        timeType: 5,
        timeDesc: '5天内'
    },
    {
        timeType: 7,
        timeDesc: '7天内'
    },
    {
        timeType: 10,
        timeDesc: '10天内'
    },
    {
        timeType: 15,
        timeDesc: '15天内'
    },
    {
        timeType: 20,
        timeDesc: '20天内'
    },
    {
        timeType: 25,
        timeDesc: '25天内'
    }
]

// 默认发货模式
export const defaultPreSale = {
    [SPOT_PRE_SALE_KEY]: {
        name: '现货发货模式',
        key: 'normalRule',
        support: true,
        delayOptions: DELIVERY_DELAY_OPTIONS,
        isSpecialDelayOption: false
    },
    [FULL_PAYMENT_KEY]: {
        name: '全款预售发货模式',
        key: 'productPresellRule',
        support: true,
        minPresellPrice: 2000,
        supportDeliveryAfterPay: false,
        supportDeliveryAfterPresell: false,
        deliveryAfterPayConfig: {
            minDeliveryDays: 2,
            maxDeliveryDays: 15,
            maxPresellEndDays: 30,
            needAudit: false
        },
        deliveryAfterPresellConfig: {
            minDeliveryDays: 2,
            maxDeliveryDays: 15,
            maxPresellEndDays: 30,
            needAudit: false
        }
    },
    [SPOT_OPENS_BOOK_KEY]: {
        name: '现货+预售发货模式',
        key: 'timeTimePresellRule',
        support: true,
        minPresellPrice: 0,
        timeSkuSpecDetial: [
            { specValue: '当日发/次日发', isPresellSpec: false },
            { specValue: '次日发', isPresellSpec: false },
            { specValue: '48小时内发货', isPresellSpec: false },
            { specValue: '5天内发货', isPresellSpec: true },
            { specValue: '15天内发货', isPresellSpec: true }
        ],
        timeSkuSpecName: '发货时效'
    },
    [STEP_RULE_V2]: {
        name: '(新)现货+预售发货模式',
        key: 'stepRuleV2',
        support: true,
        timeSaleStockRule: TIME_SALE_STOCK_RULE
    }
}

// 新发货模式
export const NEW_PRE_SALE = [SPOT_OPENS_BOOK_KEY, NEW_BOOK_KEY]

export const isNewPreSale = preSaleType => NEW_PRE_SALE.indexOf(String(preSaleType)) >= 0

export const findPreSaleName = preSaleType => PRE_SALE_MAP[preSaleType]?.name

// 度量衡
export const MEASURE_TYPE_UNITVALUE = 'value'
export const MEASURE_TYPE_UNIT = 'unit'

export const MEASURE_INPUT_TYPE_INT = 'integer'
export const MEASURE_INPUT_TYPE_FLOAT = 'float'
export const MEASURE_INPUT_TYPE_STRING = 'string'

// 属性
export const INPUT_TYPE_MULTI_SELECT = 'multi_select'
export const INPUT_TYPE_SELECT = 'select'
export const INPUT_TYPE_TEXT = 'text'
export const INPUT_TYPE_TIMEFRAME = 'timeframe'
export const INPUT_TYPE_DATE_TIME = 'date_time'
export const INPUT_TYPE_DATE_TIME_RANGE = 'date_time_range'
export const INPUT_TYPE_MEASURE = 'measure'
export const INPUT_TYPE_MULTI_VALUE_MEASURE = 'multi_value_measure'

// 商品属性
// 属性类型
export const PROPERTY_TYPE_BIND = 0 // 0 绑定属性
export const PROPERTY_TYPE_KEY = 1 // 1 关键属性
export const PROPERTY_TYPE_SELL = 2 // 2 售卖属性
export const PROPERTY_TYPE_GOODS = 3 // 3 商品属性

// 自定义属性
export const DIY_TYPE = 1

// spu 管控条件
export const SPU_CONTROL_TYPE_NO = 0 // 0不管控
export const SPU_CONTROL_TYPE_WEAK = 1 // 1弱管控
export const SPU_CONTROL_TYPE_STRONG = 2 // 2强管控

// 状态
export const SPU_STATUS_POP = 1 // 1:上线
export const SPU_STATUS_NO_POP = 2 // 2:下线
export const SPU_STATUS_UNDER = 3 // 3:审核中
export const SPU_STATUS_NO_UNDER = 4 // 4:审核不通过

// 售后服务
export const AFTER_SALE_SERVICE_7_0 = '7-0'
export const AFTER_SALE_SERVICE_7_1 = '7-1'
export const AFTER_SALE_SERVICE_7_2 = '7-2'
export const AFTER_SALE_SERVICE_7_3 = '7-3'
export const AFTER_SALE_SERVICE_7_4 = '7-4'
export const AFTER_SALE_SERVICE_7_5 = '7-5'
export const AFTER_SALE_SERVICE_7_6 = '7-6'
export const AFTER_SALE_SERVICE_7_8 = '7-8'
export const AFTER_SALE_SERVICE_15_0 = '15-0'
export const AFTER_SALE_SERVICE_15_1 = '15-1'
export const AFTER_SALE_SERVICE_15_2 = '15-2'
export const AFTER_SALE_SERVICE_15_3 = '15-3'
export const AFTER_SALE_SERVICE_15_4 = '15-4'
export const AFTER_SALE_SERVICE_15_5 = '15-5'
export const AFTER_SALE_SERVICE_15_6 = '15-6'
export const AFTER_SALE_SERVICE_15_8 = '15-8'

export const AFTER_SALE_SERVICE_MAP = {
    [AFTER_SALE_SERVICE_7_0]: '不支持7天无理由退货',
    [AFTER_SALE_SERVICE_7_1]: '7天无理由退货',
    [AFTER_SALE_SERVICE_7_2]: '7天无理由退货（一次性包装未破损）',
    [AFTER_SALE_SERVICE_7_3]: '7天无理由退货（安装后不支持）',
    [AFTER_SALE_SERVICE_7_4]: '7天无理由退货（激活后不支持）',
    [AFTER_SALE_SERVICE_7_5]: '7天无理由退货（使用后不支持）',
    [AFTER_SALE_SERVICE_7_6]: '7天无理由退货（定制类不支持）',
    [AFTER_SALE_SERVICE_7_8]: '7天无理由退货（合约版不支持）',
    [AFTER_SALE_SERVICE_15_0]: '不支持15天无理由退货',
    [AFTER_SALE_SERVICE_15_1]: '15天无理由退货',
    [AFTER_SALE_SERVICE_15_2]: '15天无理由退货（一次性包装未破损）',
    [AFTER_SALE_SERVICE_15_3]: '15天无理由退货（安装后不支持）',
    [AFTER_SALE_SERVICE_15_4]: '15天无理由退货（激活后不支持）',
    [AFTER_SALE_SERVICE_15_5]: '15天无理由退货（使用后不支持）',
    [AFTER_SALE_SERVICE_15_6]: '15天无理由退货（定制类不支持）',
    [AFTER_SALE_SERVICE_15_8]: '15天无理由退货（合约版不支持）'
}

// 运费模板
export const CALCULATE_TYPE_WEIGHT = 1 // 按重量计费
export const CALCULATE_TYPE_COUNT = 2 // 按数量计费

// 检测运费模板是否存在选择按重量计费
export const checkFreightsHasCalculateByWeight = ({ shopShelvesFreights }) => {
    if (!Array.isArray(shopShelvesFreights)) {
        return false
    }

    return shopShelvesFreights.some(v => v?.data?.calculateType === CALCULATE_TYPE_WEIGHT)
}

export const MIN_PRICE = 0.01
export const MAX_PRICE = 999999.99

export const MIN_GOLD_PRICE = 0
export const MAX_GOLD_PRICE = 999999.99

export const MIN_QUANTITY = 0
export const MAX_QUANTITY = 999999

export const MIN_WEIGHT = 0.001
export const MAX_WEIGHT = 9999.999

// 报错文本
export const ERROR_TEXT_SPU_GOODS = '该类目需要基于标品发布商品，根据关键属性在该类目未找到标品，请先新建标品或调整类目'
export const ERROR_TEXT_SHELVE_SIZES =
    '创建的尺码表信息需与sku尺码规格信息保持一致，请调整尺码表模版或者调整尺码规格值后，再进行发布，'
export const ERROR_URL_SHELVE_SIZES =
    'https://school.jinritemai.com/doudian/web/article/aHta6ih1KgPt?rank=3&fromPage=search_result&searchInfo=18430363135844978188%3A3%3A0%3A1424546883%3A20231110173648CFFE154D6B7B99DF9C57&query=%E5%B0%BA%E7%A0%81%E6%A8%A1%E7%89%88&resultType=%E5%8A%9F%E8%83%BD&from=shop_article&btm_ppre=a4977.b5856.c0.d0&btm_pre=a4977.b6444.c0.d0&btm_show_id=3201a31e-7c6a-49c4-b9de-27a6bddb7410'

// 是否选择当日金价
export const DAY_GOLD_PRICE_OPTIONS = [
    {
        value: true,
        label: '是'
    },
    {
        value: false,
        label: '否'
    }
]

// 短标题
export const MIN_SHORT_NAME = 8
export const MAX_SHORT_NAME = 24

// 属性 name
export const CATA_BRAND_NAME = '品牌'

export const SIZE_NAMES = ['尺码', '尺码大小', '鞋码大小', '尺码分类']

export const SIZE_SHOP = 'SHOP'
export const SIZE_ITEM = 'ITEM'

// 三包服务承诺
export const THREE_GUARANT_TYPE_WITHIN = '1' // 保修期内提供维修
export const THREE_GUARANT_TYPE_EXTEND = '2' // 延长售后服务有效期

export const DURATION_LABEL_MAP = {
    [THREE_GUARANT_TYPE_WITHIN]: '选择保修天数',
    [THREE_GUARANT_TYPE_EXTEND]: '选择售后服务有效期'
}

// 不提供上门安装
export const NO_HOME_INSTALL_SERVICE_LABEL = '不提供上门安装'
export const NO_HOME_INSTALL_SERVICE_VALUE = '0'
